module.exports = __webpack_public_path__ + "img/icon_map_36_on_010.b73d56ec.png";